import PropTypes from 'prop-types';
import { Component } from 'react';

import { Button } from '@mui/material';

import SortableTableComponent from '../Table/SortableTableComponent';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';

import InfoComponent from '../Info';
import CellPersonWithImage from '../Table/CellPersonWithImage';

class SelectPersonComponent extends Component {
  componentWillUnmount() {
    const { onUnmount } = this.props;
    if (onUnmount) {
      onUnmount();
    }
  }

  render() {
    const { people, onCancel, formValues, onSelect } = this.props;
    const columns = [
      {
        Header: 'Name',
        id: 'last_name',
        headerClassName: 'sort',
        dataKey: 'lastName',
        accessor: (entry) => <CellPersonWithImage person={entry} />,
      },
      {
        Header: 'Actions',
        id: 'actions',
        fixed: 'right',
        sortable: false,
        width: 120,
        accessor: (entry) => (
          <Button
            variant="contained"
            fullWidth
            disableElevation
            color="primary"
            onClick={() => onSelect(entry, formValues)}
          >
            Use Me
          </Button>
        ),
      },
    ];

    if (!people?.length) return null;
    return (
      <div>
        <InfoComponent isWarning>
          Someone with that email and/or phone exists already.
          <br />
          Is one of these people the one you&apos;re looking for?
        </InfoComponent>
        <SortableTableComponent
          tableId={TABLE_ID.selectPersonTable}
          columns={columns}
          defaultSort={TABLE_CONSTANTS.last_name}
          entries={people}
          pluralModelName="people"
        />
        <Button variant="contained" disableElevation onClick={() => onCancel()}>
          No, go back to editing info
        </Button>
      </div>
    );
  }
}

SelectPersonComponent.defaultProps = {
  onCancel: () => {},
  formValues: {},
};

SelectPersonComponent.propTypes = {
  people: PropTypes.instanceOf(Array).isRequired,
  onSelect: PropTypes.func.isRequired,
  onUnmount: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Object),
  onCancel: PropTypes.func,
};

export default SelectPersonComponent;
